import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import phoneRolesReducer from "./rolesLst/slice/phone.ts";
import webCandidatesReducer from "../features/OldVersionCandidate/RoleCandidates/redux/slices/web.ts";
import phoneCandidatesReducer from "../features/OldVersionCandidate/RoleCandidates/redux/slices/phone.ts";
import userReducer from "../features/User/redux/slice.ts";
import webRolesReducer from "./rolesLst/slice/web.ts";

export const store = configureStore({
  reducer: {
    phone: phoneRolesReducer,
    web: webRolesReducer,
    user: userReducer,
    webCandidates: webCandidatesReducer,
    phoneCandidates: phoneCandidatesReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
